import { http } from "../../../config/HttpMethod";
import { MotorDto } from "../../../store/model/calculations/motor";
import { ESP_ENDPOINTS } from "../endpoints";


export const GetMotorList = async (postData: (string | number)[]) => {
    const response = await http.post<MotorDto[]>(`${ESP_ENDPOINTS?.GET_MOTOR_LIST}`, postData);
    return response.data;
}

export const GetMotorIteration = async (inputData: (string | number)[], hpReq: (string | undefined), opFreq: string) => {
    var postData = { InputData: inputData, HPReqd: hpReq, OpFreq: opFreq };
    const response = await http.post<any>(`${ESP_ENDPOINTS?.GET_MOTOR_ITERATION}`, postData);
    return response.data;
}

export const GetMotorCalculation = async (liqVolRate: (string | undefined), casingId: (string | undefined), casingIdUnit: string, motrOD: string, unitSys: string, casingOD: (string | undefined), ShroudFlag: string, shrdOD: string, watrVolm: (string | undefined), MtrID: string, catalogFilter: number) => {

    const parmsdata = 'LiqVolRate=' + liqVolRate + '&CasingID=' + casingId + '&CasingIDUnt=' + casingIdUnit + '&MotrOD=' + motrOD + '&UnitSystm=' + unitSys + '&CasingOD=' + casingOD + '&ShroudFlag=' + ShroudFlag + '&ShroudOD=' + shrdOD + '&WatrVolm=' + watrVolm + '&MotrID=' + MtrID + '&catalogFilter=' + catalogFilter;
    const response = await http.get<any>(`${ESP_ENDPOINTS?.GET_MOTOR_CALCULATION}` + parmsdata);
    return response.data;
}

export const GetShroudWeight = async (casingOD: string, unitSys: string) => {

    const parmsdata = 'CasingOD=' + casingOD + '&UnitSystm=' + unitSys;
    const response = await http.get<any>(`${ESP_ENDPOINTS?.GET_SHROUD_OD}` + parmsdata);
    return response.data;
}


export const GetShroudFluidVelocityPostMotor = async (postData: any) => {
    const response = await http.post<any>(`${ESP_ENDPOINTS?.GET_SHROUD_CALCULATION}`, postData);
    return response.data;
}

export const GetMotorPerformancePlotData = async (motorId: string, targetMotorLoad: number) => {
    const parmsdata = 'motorId=' + motorId + '&targetMotorLoad=' + targetMotorLoad;
    const response = await http.get<any>(`${ESP_ENDPOINTS?.GET_MOTOR_PERFORMANCE_DATA}` + parmsdata);
    return response.data;
}

export const fetchEquipments = async (motorSeries: string, catalogFilter: number) => {
    const parmsdata = 'series=' + motorSeries + '&catalogFilter=' + catalogFilter;
    const response = await http.get<any>(`${ESP_ENDPOINTS?.GET_SR_MOTORS}` + parmsdata);
    return response.data;
}

export const getMtrOilTempChk = async (data: any) => {
    const response = await http.post<any>(`${ESP_ENDPOINTS?.GET_MOTOR_OIL_TEMP_CHK}`, data);
    return response.data;
}

// getMtrOilTempChk(data: object) {
//     return this.httpClient.post<any>(`Determine/ESP/MtrOilTempChk`, data);
// }


